import { bindable } from 'aurelia-framework';

import TomSelect from 'tom-select';
import 'tom-select/dist/css/tom-select.bootstrap5.css';

export class AutoComplete {
    @bindable service;
    @bindable value;
    @bindable text;
    @bindable extraParam;
    @bindable openFocus;
    @bindable disabled;

    bind(bindingContext) {
        this.parent = bindingContext;
    }

    attached () {
        if (this.disabled) {
            const val = document.createElement('option');
            val.innerText = this.text;
            val.value = this.value;
            this.element.append(val);
            return;
        }
        this.select = new TomSelect(this.element, {
            valueField: 'id',
            labelField: 'name',
            searchField: 'name',
            options: this.text != null && this.text.length > 0 ? [{ id: this.value, name: this.text }] : [],
            items: [this.value],
            selectOnTab: true,
            load: async (query, callback) => {
                const items = await this.service.filterTopThree(query, this.extraParam);
                callback(items);
            },
            onChange: (value) => {
                this.value = value;
                this.text = this.select.activeOption.innerText;
            }
        });

        if (!this.parent.hasFocusedElement && this.parent.uxBody != undefined) {
            let inputContainer = this.parent.uxBody.querySelector('.form-group');
            if (inputContainer.querySelector('input') != null) {
            inputContainer.querySelector('input').click();
            }
            this.parent.hasFocusedElement = true;
        }

        if (this.openFocus) {
            this.select.focus();
        }
    }

    clearSelection () {
        this.select.clear();
        this.value = null;
    }
}